import {DOC_TYPE} from '@/constants/document/doc';

export const DEFAULT_TITLE = '未命名文档';
export const DEFAULT_BOOK_TITLE = '未命名知识本';
export const DEFAULT_SHEET_TITLE = '未命名表格';
export const DEFAULT_PPT_TITLE = '未命名演示文稿';
export const DEFAULT_DATASHEET_TITLE = '未命名数据表夹';
export const TITLE_MAX_LENGTH = 100;
export const INTRO_MAX_LENGTH = 51;
export const ERROR_TIP = '网络错误，请重新输入名称';

export const DOC_TYPE_DEFAULT_TITLE: {[key: number]: string} = {
    [DOC_TYPE.DOCUMENT]: DEFAULT_TITLE,
    [DOC_TYPE.SHEET]: DEFAULT_SHEET_TITLE,
    [DOC_TYPE.PPT]: DEFAULT_PPT_TITLE,
    [DOC_TYPE.DIRECTORY]: DEFAULT_BOOK_TITLE,
    [DOC_TYPE.DATASHEET]: DEFAULT_DATASHEET_TITLE,
};
